import React, {Component} from 'react';
import {
    Input,
} from 'antd';
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import {setUser} from '../redux/actions'
import {HashRouter as Router, Route, Link, Switch, Redirect} from "react-router-dom";

class PageOne extends Component {
    constructor(props) {
        super(props)
        this.state = {
            value: 'Bougie'
        }
    }
    static propTypes = {
        user: PropTypes.string
    }
    handleStateChange = (event) => {
        this.setState({value: event.target.value})
    }
    handleReduxChange = (event) => {
        this
            .props
            .setUser(event.target.value)
    }
    render() {
        return <div>
            <div className="redux-test test-wrapper">
                <h2>双向绑定</h2>
                state: 
                <Input onChange={this.handleStateChange} value={this.state.value} />
                redux:
                <Input onChange={this.handleReduxChange} value={this.props.user} />
                <div>
                    state: {this.state.value}
                </div>
                <div>
                    redux: {this.props.user}
                </div>
            </div>
            <div className="test-wrapper">
                <h2>路由嵌套</h2>
                <Router>
                    <div>
                        <ul>
                            <li>
                                <Link to="/one/child/33/150/243">Home</Link>
                            </li>
                            <li>
                                <Link to="/one/child/44/200/256">About</Link>
                            </li>
                            <li>
                                <Link to="/one/child/55/220/243">Topics</Link>
                            </li>
                        </ul>
                        <Route path='/one/child/:r/:g/:b' component={RGB} />
                    </div>
                </Router>
            </div>
        </div>
    }
}

// const RGB = ({ match: { params } }) => (
//     <div style={{background: `rgb(${params.r}, ${params.g}, ${params.b})`}}>
//         rgb({params.r}, {params.g}, {params.b})
//     </div>
// );

class RGB extends Component {
    render() {
        const { params } = this.props.match
        return <div style={{background: `rgb(${params.r}, ${params.g}, ${params.b})`}}>
            rgb({params.r}, {params.g}, {params.b})
        </div>
    }
}

const mapStateToProps = (state, ownProps) => ({user : state.pageOne.user}) 
const mapDispatchToProps = {setUser}

export default connect(mapStateToProps, mapDispatchToProps)(PageOne)


// WEBPACK FOOTER //
// ./src/pages/PageOne.js